import { atom } from "jotai";

import { TUser } from "~/_types/TUser";

// TODO SSR에서 need_hydration 처리 필요함
export const userAtom = atom<TUser | null>(null);
